import { useEffect, useState } from "react";
import socket from "./socket"; // Import the Socket.IO connection
import axios from "axios";

const API_URL = "https://techservicemarket-backend.onrender.com/api/messages";

/**
 * Joins a chat room and listens for incoming messages.
 */
export const useChat = (conversationId) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (conversationId) {
      socket.emit("joinRoom", { conversationId });
      fetchMessages();
    }
    
    // Remove the socket listener from here since it's handled in the Messaging component
    return () => {
      // Clean up only the room joining if needed
      if (conversationId) {
        socket.emit("leaveRoom", { conversationId });
      }
    };
  }, [conversationId]);

  const fetchMessages = async () => {
    if (!conversationId) {
      console.log("No conversation ID provided.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/${conversationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Fetched messages:", response.data);
      setMessages(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  return { messages, setMessages };
};

/**
 * Sends a message to the chat.
 */
export const sendMessage = async (conversationId, userId, message, setMessage, setMessages) => {
  if (!message.trim()) return;

  const newMessage = {
    conversationId,
    senderId: userId,
    message,
    timestamp: new Date().toISOString(),
  };

  // Emit message via socket
  socket.emit("sendMessage", newMessage);

  // Optimistically update local state
  setMessages((prev) => [...prev, newMessage]);

  try {
    await axios.post(`${API_URL}/message/send`, 
      { conversationId, message }, 
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` 
      },
    });

    setMessage("");
  } catch (error) {
    console.error("Error sending message:", error);
  }
  
};
